import { combineReducers } from "redux";
import loginReducer from "../redux/reducers/loginReducer"
import forgotPwdReducer from "./reducers/forgotPwdReducer";
import profileSettings from "./reducers/profileSettingReducer";
import  getCountries  from "./reducers/countriesReducer";
import watchedHourMetricsRes  from "./reducers/watchedHoursMetricsReducer";
import topContentViews from "./reducers/topContentByViewsReducer";
import watchedHoursGrid from "./reducers/watchedHoursGridReducer"
import  moviesRes  from "./reducers/moviesListReducer";
const rootReducer = combineReducers({
    loginReducer,
    forgotPwdReducer,
    profileSettings,
    getCountries,
    watchedHourMetricsRes,
    topContentViews,
    watchedHoursGrid,
    moviesRes

})
export default rootReducer;